import React, { useState, useEffect } from 'react';
import AuthService from '../services/AuthService';
import {  useNavigate, NavLink} from 'react-router-dom';
import { toast } from 'react-toastify';

import ApiService from "../services/ApiService";
import AreaChart from "../components/AreaChart";

const Dashboard = () => {
  const navigate = useNavigate();
  
  const [isLoader, setIsLoader] = useState(false);
  const [stats, setStats] = useState([]);
  const [charts, setCharts] = useState([]);
  const [current_month, setCurrentMonth] = useState("");

useEffect(() => {
    const isAuthenticated = AuthService.getCurrentUser(); // Check if the user is authenticated
    if (!isAuthenticated) {
        navigate('/login'); // Redirect to dashboard if authenticated
    }
    getDashboard();

    const now = new Date();
    const options = { month: "short", year: "numeric" }; // e.g., Dec, 2024
    const formattedDate = now.toLocaleDateString("en-US", options);
    setCurrentMonth(formattedDate);

}, [navigate]);


const getDashboard = async () => {
    try {
        setIsLoader(true);
        const response = await ApiService.request({
            method: "GET",
            url: "getDashboard", // Replace with your API endpoint
        });
        const data = response.data;
        if (data.status) {
            setStats(data.data.stats);
            setCharts(data.data.charts);
        } else {
            toast.error(data.message);
        }
        setIsLoader(false);
    } catch (error) {
        setIsLoader(false);
    }
   
};

  return (
    <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
            <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                        Dashboard 
                    </h1>
                    <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                        <li className="breadcrumb-item text-muted">
                            <a href="/TimeLogger/admin/" className="text-muted text-hover-primary"> Home </a>
                        </li>
                        <li className="breadcrumb-item">
                            <span className="bullet bg-gray-400 w-5px h-2px"></span>
                        </li>
                        <li className="breadcrumb-item text-muted"> Dashboard </li>
                    </ul>
                </div>
                <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
            </div>
        </div>

        <div id="kt_app_content" className="app-content flex-column-fluid">
            <div id="kt_app_content_container" className="app-container container-fluid">
                <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/tests" className="card border bg-base shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-white text-uppercase mb-2"> Tests Listed </div>
                                        <div className="h1 mb-0 font-weight-bold text-white">{stats?.total_tests}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-card-list fs-3x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>
                   
                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/attempts?status=Active" className="card border bg-base shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-white text-uppercase mb-2"> Active Tests </div>
                                        <div className="h1 mb-0 font-weight-bold text-white">{stats?.active_tests}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-card-text fs-3x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>
                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/attempts?status=Completed" className="card border bg-base shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-white text-uppercase mb-2"> Completed Tests </div>
                                        <div className="h1 mb-0 font-weight-bold text-white">{stats?.completed_tests}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-card-checklist fs-3x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>


                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/interviews" className="card border bg-base shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-white text-uppercase mb-2"> Total Courses </div>
                                        <div className="h1 mb-0 fw-bold text-white">{stats?.total_interviews}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-person-video fs-3x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>

                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/payments?type=interview" className="card border bg-base shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-white text-uppercase mb-2"> Courses Purchased  </div>
                                        <div className="h1 mb-0 fw-bold text-white">{stats?.interviews_purchased}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-person-video fs-3x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>

            
                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/users" className="card border bg-base shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-white text-uppercase mb-2"> Total Users </div>
                                        <div className="h1 mb-0 fw-bold text-white">{stats?.total_users}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-people fs-3x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>

                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/packages" className="card border bg-base shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-white text-uppercase mb-2"> Total Packages</div>
                                        <div className="h1 mb-0 font-weight-bold text-white">{stats?.total_packages}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-tag fs-3x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>
                    <div className="col-xl-3 col-md-6 mb-4">
                        <NavLink to="/payments?type=subscription" className="card border bg-base shadow h-100 py-2">
                            <div className="card-body">
                                <div className="row no-gutters align-items-center">
                                    <div className="col mr-2">
                                        <div className="fs-6 fw-bold text-white text-uppercase mb-2"> Subscription Purchased</div>
                                        <div className="h1 mb-0 font-weight-bold text-white">{stats?.packages_purchased}</div>
                                    </div>
                                    <div className="col-auto">
                                        <i className="bi bi-tag fs-3x text-gray-300"></i>
                                    </div>
                                </div>
                            </div>
                        </NavLink>
                    </div>

                </div>

                <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                    <div className="col-md-6">
                        <div className="card card-flush overflow-hidden">
                            <div className="card-header pt-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark">Users Stats</span>
                                    <span className="text-gray-400 mt-1 fw-semibold fs-6"> Users registered per month</span>
                                </h3>
                                <div className="card-toolbar"></div>
                            </div>
                            <div className="card-body d-flex align-items-end">
                                <div className="p-chart h-300px w-100" style={{ position: 'relative' }}>
                                    <AreaChart labels={charts.months} label='Users' dataset={charts.month_users} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="card card-flush overflow-hidden">
                            <div className="card-header pt-5">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label fw-bold text-dark"> {current_month} Test Attempts </span>
                                    <span className="text-gray-400 mt-1 fw-semibold fs-6">This Month Test Attempts</span>
                                </h3>
                                <div className="card-toolbar"></div>
                            </div>
                            <div className="card-body d-flex align-items-end">
                                <div className="p-chart h-300px w-100"  style={{ position: 'relative' }}>
                                <AreaChart labels={charts.dates} label='Test Attempts' dataset={charts.day_test} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Dashboard;
